import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { JobTypeService } from '../jobtypes.service';
import { JobType } from '../jobtypes';
import { Observable, empty } from 'rxjs';
import { map, debounceTime, finalize, switchMap, tap, startWith, filter } from 'rxjs/operators';
import { API, APIDefinition, Columns, Config, DefaultConfig } from 'ngx-easy-table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Contact } from '../../contacts/contact';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { MessagerComponent } from '../../messager/messager/messager.component';
import { ContactsService } from '../../contacts/contacts.service';
import { GridDeleteComponent } from '../../utils/grid-delete-component';
import { AuthService } from '../../auth.service';
import { LoggingService } from '../../utils/logging.service';
import { GlobalEmailService } from '../../utils/globalemail.service';
import { ADDING_MODE, EDITING_MODE } from 'src/app/utils/constants';


@Component({
  selector: 'app-edit-jobtype',
  templateUrl: './edit-jobtype-dialog.html',
  styleUrls: ['./jobtypes.component.css']
})

export class EditJobtypeDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<EditJobtypeDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: JobType, private fb:FormBuilder, public service: JobTypeService, private messager: MessagerComponent, public contactService: ContactsService, public log: LoggingService) {}

  form = new FormGroup({
    job_type_id : new FormControl(this.data.job_type_id || ''),
    job_type : new FormControl(this.data.job_type || ''),
    inactivejobtype : new FormControl(this.data.inactivejobtype || false),
    sitevisitrqd : new FormControl(this.data.sitevisitrqd || false),
    buildstage : new FormControl(this.data.buildstage || ''),
    ratercompid : new FormControl(this.data.ratercompid || ''),
    officejob : new FormControl(this.data.officejob || false),
    certsreqd : this.fb.array(this.data.certsreqd || []), 
    category : new FormControl (this.data.category || '')
  });



  @ViewChild('refname', {read: false, static: false})
  refNameInputRef: ElementRef;
  mode = this.data.mode;
  isLoading = false;
  isDuplicate=false;
  textToDisplay="";
  display = false ; 
  inactive;

  certifications = ['RFI', 'HvG', 'ESSF', 'ESMF', 'NGBS', 'EI'];
  

  ngOnInit() {
    //pre-fill dropdowns here
    this.inactive = this.data.inactivejobtype;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onToggleInactive(): void {
    this.inactive = !this.inactive;
  }

  isChecked(value: string): boolean {
    return this.form.value.certsreqd.includes(value);
  }

  onCertSelected(event, value: string){
    if(event.checked){
      this.form.value.certsreqd.push(value);
    } else {
      const index = this.form.value.certsreqd.indexOf(value);
      if (index > -1) {
        this.form.value.certsreqd.splice(index, 1);
      }
    }
  }


  save(): void {

    let changedProperties = [];
      Object.keys(this.form.controls).forEach((name) => {
            const currentControl = this.form.controls[name];
            if (currentControl.dirty) {
              changedProperties.push(name +': ' + this.form.controls[name].value);
            }
      });
    this.service.saveEdit(this.data.job_type_id, this.form.value).subscribe(
      res => {
        this.dialogRef.close();
        if(res.Error){
          this.log.error(this.data.loggedIn + ' encountered an error editing a jobtype: Submitted data: ' + '{' + this.form.value.toString() + '} ' + res.Message );
        }else{
          this.log.info(this.data.loggedIn + ' saved the following edits to jobtype ' + this.form.value.job_type.trim() + ' {' + changedProperties.toString() + '}' );
        }
      },
      err => {
        this.log.error(this.data.loggedIn + ' encountered an error editing a jobtype: Submitted data: ' + '{' + this.form.value.toString() + '} ' + err.toString() );
      }
    );

  }

  checkForDuplication(){
    if(this.form.get('job_type').value.length > 0){
      this.service.checkJobExist(this.form.get('job_type').value).subscribe(
        res=>{
          if(res.Length > 0){
            this.textToDisplay = 'This is a duplicate, please change  the jobtype!';
            this.isDuplicate = true;
          } else {
            this.textToDisplay = 'This is a new customer job.';
            this.isDuplicate = false;
          }
          this.display = true;
        },
        err=>{
        }
      )
    }else{
      this.display = false 
    }

  }

  add(): void {
    this.service.add(this.form.value).subscribe(
      res => {
        this.dialogRef.close();
        if(res.Error){
          this.log.error(this.data.loggedIn + ' encountered an error editing a jobtype: Submitted data: ' + '{' + this.form.value.toString() + '} ' + res.Message );
        }else{
          this.log.info(this.data.loggedIn + ' created the jobtype ' + this.form.value.job_type.trim() );
        }
      },
      err => {
        this.log.error(this.data.loggedIn + ' encountered an error editing a jobtype: Submitted data: ' + '{' + this.form.value.toString() + '} ' + err.toString() );
      }
    );
  }
}



@Component({
  selector: 'app-jobtypes',
  templateUrl: './jobtypes.component.html',
  styleUrls: ['./jobtypes.component.css']
})
export class JobtypesComponent implements OnInit {

  public configuration: Config;
  public columns: Columns[];
  editData;

  faedit = faEdit;
  fatrash = faTrashAlt;
  facopy = faCopy;

  user;
  usernamee;

  modal = false;
  activeJobToggle = false;
  selected;

  gridEntrie$: Observable<JobType[]>;
  filterActiveJob$: Observable<JobType[]>;
  displayedColumns: string[] = ['job_type'];
  canSeeCertsEdit: boolean = true;

  constructor(public jobTypeService: JobTypeService, public dialog: MatDialog, public auth: AuthService, public log: LoggingService) { }


  ngOnInit(): void {

    this.jobTypeService.init();
    this.configuration = {...DefaultConfig};
    this.configuration.tableLayout.theme = 'lIGHT';
    this.configuration.tableLayout.style = 'big';
    this.configuration.tableLayout.borderless = false;
    this.configuration.tableLayout.hover = true;
    this.configuration.searchEnabled = true;
    this.configuration.paginationEnabled = true;
    this.configuration.paginationRangeEnabled = false;
    this.configuration.isLoading = true;
    this.configuration.rows = 100;

    this.gridEntrie$ = this.jobTypeService.getInitial().pipe(
      tap(() => {
        this.configuration.isLoading = this.jobTypeService.isLoading;
      })
    );

    this.filterActiveJob$ = this.gridEntrie$;

    this.columns = [
      { key: '', title: '', searchEnabled: false, width: '5%'},
      { key: 'job_type', title: 'Job Type'},
      { key: 'certsreqd', title: 'Certs Required'}
    ]

    this.auth.getUser$().subscribe((res) => {
    });

    this.auth.userProfile$.subscribe(
      (profile) => {
        this.user = profile;
        this.usernamee = this.user ? this.user.nickname.charAt(0).toUpperCase() + this.user.nickname.slice(1) : '';
    });

  }

  openDialog(myData): void {

    this.jobTypeService.getOneJobType(myData.job_type_id).subscribe(
      (tdata: any) => {

        const dialogRef = this.dialog.open(EditJobtypeDialogComponent, {
          width: '400px',
          data: {
            job_type_id : tdata.Jobtypes.job_type_id,
            job_type : tdata.Jobtypes.job_type,
            inactivejobtype : tdata.Jobtypes.inactivejobtype,
            sitevisitrqd : tdata.Jobtypes.sitevisitrqd,
            buildstage : tdata.Jobtypes.buildstage,
            ratercompid : tdata.Jobtypes.ratercompid,
            officejob : tdata.Jobtypes.officejob,
            certsreqd : tdata.Jobtypes.certsreqd,
            category : tdata.Jobtypes.category,
            mode: EDITING_MODE,
            loggedIn : this.usernamee || 'User',
            canSeeCerts : this.canSeeCertsEdit
          },
          panelClass: 'edit-jobType-dialog'
        });

        dialogRef.afterClosed().subscribe(result => {
          this.editData = result;
        });

      }
    )
  }

  filterActiveJobs(): void {
    this.activeJobToggle = !this.activeJobToggle;
    if (this.activeJobToggle) {
      this.filterActiveJob$ = this.gridEntrie$.pipe(
        map((jobs) => jobs.filter((job) => job.inactivejobtype === false))
      );
    } else {
      // Reset to the original list
      this.filterActiveJob$ = this.gridEntrie$;
    }
  }

  addDialog(): void {

    const dialogRef = this.dialog.open(EditJobtypeDialogComponent, {
      width: '400px',
      data: {
        canSeeCerts: true,
        mode: ADDING_MODE
      },
      panelClass: 'edit-jobType-dialog'
    });

  }

  copy(row): void {
    this.jobTypeService.copy(row).subscribe(
      res => {
        if (res.JobType) {
          this.jobTypeService.addOneFrontend(res.JobType);
          this.log.info(this.usernamee + ' copied the job type: ' + row.job_type + ' id: ' + row.job_type_id);
        }
      }, err => {
        this.log.error(this.usernamee + ' encountered an error copying the job type: ' + row.job_type + ' id: ' + row.job_type_id + ' ' + err.toString());
      }
    );
  }

  delete(row): void {
    const dialogRef = this.dialog.open(GridDeleteComponent, {
      width: '500px',
      data: {
        delete_body_text: 'Are you sure you want to delete this job type?',
        delete_api_url: '/rhAPI/jobEntry/deleteJobType/',
        delete_id: row.job_type_id,
        delete_header_text: 'Deleting ' + row.job_type
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {
        this.jobTypeService.deleteOne(row.job_type_id);
        this.log.info(this.usernamee + ' deleted the job type: ' + row.job_type + ' id: ' + row.job_type_id);
      }
    });
  }


}
